<template>
    <NuxtLink :to="$withLocalePrefix(href)" class="product-link" :class="{'product-link--ai': theme === 'ai'}" external>
        <slot />
    </NuxtLink>
</template>

<script lang="ts" setup>
    defineProps<{href: string; theme?: 'malt' | 'ai'}>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    $chevrong-svg-mask: url('data:image/svg+xml,<svg viewBox="0 0 8 20" xmlns="http://www.w3.org/2000/svg"><path d="M 2.707 5.293 C 2.317 4.903 1.683 4.903 1.293 5.293 C 0.902 5.684 0.902 6.317 1.293 6.708 L 4.586 10 L 1.293 13.293 C 0.902 13.684 0.902 14.317 1.293 14.708 C 1.683 15.098 2.317 15.098 2.707 14.708 L 6.707 10.708 C 7.098 10.317 7.098 9.684 6.707 9.293 L 2.707 5.293 Z" fill-rule="evenodd" clip-rule="evenodd"></path></svg>');

    .product-link {
        display: inline-block;
        position: relative;
        color: var(--joy-color-primary-50);
        letter-spacing: 0.3px;
        font-weight: var(--joy-font-weight-bold);
        user-select: none;
        font-size: var(--joy-font-size-primary-400);
        line-height: var(--joy-line-height-large);
        padding-bottom: 2px;

        &:before {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background-color: var(--joy-color-primary-30);
            transition: transform var(--ai-transition-duration-short) var(--ai-transition-timing-function);
            transform: translate3d(-100%, 0, 0);
        }

        &:after {
            display: block;
            position: absolute;
            bottom: -10px;
            right: -15px;
            transform: translateY(-50%);
            transition: mask-position var(--ai-transition-duration-short) linear;
            width: 8px;
            height: 20px;
            background-color: var(--joy-color-primary-50);
            content: '';
            mask-image: $chevrong-svg-mask;
            mask-position: 0 0px;
            mask-repeat: repeat-x;
        }

        &:hover {
            &:before {
                transform: translate3d(0, 0, 0);
            }
            &:after {
                mask-position: 8px 0px;
            }
        }

        &--ai {
            color: var(--joy-color-ai-primary-30);
            &:before {
                background-color: var(--joy-color-ai-primary-30);
            }
            &:after {
                background-color: var(--joy-color-ai-primary-30);
            }
        }
    }
</style>
